import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import ModelViewer from '@/components/ModelViewer';
import { IPostAttachment } from '@/redux/post/post.d';

interface ModelPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  model: IPostAttachment | null;
}

function ModelPreviewModal({ isOpen, onClose, model }: ModelPreviewModalProps) {
  if (!model) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl max-h-[90vh] p-0">
        <DialogHeader className="p-6 pb-0">
          <DialogTitle className="text-xl font-semibold">
            {model.fileName}
          </DialogTitle>
        </DialogHeader>

        <div className="px-6 pb-6">
          <div className="w-full h-[70vh] rounded-lg overflow-hidden border">
            <ModelViewer
              modelURL={model.url}
              enableGrid
              backgroundColor="lightgray"
              gridColor="#696969"
              modelColor="green"
              boundingBoxColor="gray"
              dTextColor="black"
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ModelPreviewModal;
